const columnLetterToNumber = (column) => {
  let value = null;
  for (let i = 0; i < column?.length; i++) {
    value *= 26;
    value += column.charCodeAt(i) - 64;
  }
  return value;
};

export const calculateDistanceBetweenColumns = (columnStart, columnEnd) => {
  if (!columnStart?.length || !columnEnd?.length) {
    return null;
  }
  const distance =
    columnLetterToNumber(columnEnd) - columnLetterToNumber(columnStart);
  return distance > 0 ? distance + 1 : null;
};
